export const rc1 = 'rc1';
export const rc2 = 'rc2';
export const rc3 = 'rc3';
export const rc4 = 'rc4';

const match = window.location.pathname.match(/^([/0-9a-zA-Z_-]*)\/view\/o\/([0-9a-zA-Z_]*)\/.*$/);

//  NOTE (JJP - 5/20/19): This was refactored to check for undefined to support storybook with redux connected
//  components. Previously, it assumed that there would always be a "match" value
const initialState = {
  openACSHost: '',
  entryPoint: match ? match[0] : null,
  mount: match ? match[1] : null,
  orgCode: match ? match[2] : null
};

export default function reducer(state = initialState, action) {
  if ([rc1, rc2, rc3, rc4].includes(action.type)) {
    const { mount, orgCode } = state;
    return {
      openACSHost: `https://${action.type}.marketpay.net`,
      mount,
      orgCode
    };
  }
  return state;
}
